import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Card,
  Drawer,
  Group,
  LoadingOverlay,
  Modal,
  ScrollArea,
  useMantineTheme,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import EditIcon from "@mui/icons-material/Edit";
import { DEL_SUPPLIER_Commission } from "apollo/mutuations";
import { GET_SUPPLIERS_Commission } from "apollo/queries";
import B2bTable from "components/reusable/b2bTable";
import { customLoader } from "components/utilities/loader";
import { useEffect, useState } from "react";
import { FiEye } from "react-icons/fi";
import { Trash } from "tabler-icons-react";

import CommisstionDetailModal from "components/SupplierCommission/CommisstionDetail";
import CommissionAddModal from "components/SupplierCommission/CommistionAddModal";
import CommissionEditModal from "components/SupplierCommission/CommistionEditModal";
import ActionButton from "components/controls/ActionButtonNew";

const SupplierCommission = ({ isSme = false }) => {
  const [size, setSize] = useState("10");
  const [opened, setOpened] = useState(false);
  const [openedDelete, setOpenedDelete] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  const [editId, setEditId] = useState();
  const [deleteID, setDeleteID] = useState(false);
  const [openedDetail, setOpenedDetail] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const [activePage, setActivePage] = useState(1);
  const [total, setTotal] = useState(0);

  const { data, loading } = useQuery(GET_SUPPLIERS_Commission, {
    variables: {
      first: parseInt(size),
      page: activePage,
      search: searchValue,
      is_sme: isSme,
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message: error?.graphQLErrors?.[0]?.message || "Failed to Get Data",
      });
    },
  });

  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };
  useEffect(() => {
    if (data) {
      setTotal(data.supplier_configurations.paginatorInfo.lastPage);
    }
  }, [data, size]);

  const [delRetailer] = useMutation(DEL_SUPPLIER_Commission, {
    update(cache, { data: { deleteSupplier } }) {
      cache.updateQuery(
        {
          query: GET_SUPPLIERS_Commission,
          variables: {
            first: parseInt(size),
            page: activePage,
            search: "",
            is_sme: isSme,
          },
        },
        (data) => {
          if (data.supplier_configurations.data.length === 1) {
            setTotal(total - 1);
            setActivePage(activePage - 1);
          } else {
            return {
              supplier_configurations: {
                data: [
                  ...data.supplier_configurations.data.filter(
                    (supplier) => supplier.id !== deleteRetailer.id,
                  ),
                ],
              },
            };
          }
        },
      );
    },
  });

  const handleDelete = (id) => {
    setOpenedDelete(true);
    setDeleteID(id);
  };

  const deleteRetailer = () => {
    delRetailer({
      variables: { id: deleteID },
      refetchQueries: [
        {
          query: GET_SUPPLIERS_Commission,
          variables: {
            first: 10,
            page: 1,
            is_sme: isSme,
          },
        },
      ],
      onCompleted(data) {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Commission Deleted Successfully",
        });
      },
      onError(error) {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "red",
          title: "Error",
          message: `${error}`,
        });
      },
    });
  };

  const handleEditRetailer = (id) => {
    setOpenedEdit(true);
    setEditId(id);
  };

  const handleChange = (currentPage) => {
    setActivePage(currentPage);
  };
  const theme = useMantineTheme();
  const handleManageRetailer = (id) => {
    setEditId(id);
    setOpenedDetail(true);
  };
  const headerData = [
    {
      label: isSme ? "SME Supplier Name" : "Supplier Name",
      key: "name",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.supplier.user?.name}</span>;
      },
    },
    {
      label: "Email",
      key: "email",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.supplier.user?.email}</span>;
      },
    },
    {
      label: "Commission Rate",
      key: "commission_rate",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.commission_rate}</span>;
      },
    },
    {
      label: "Payment Rate",
      key: "payment_mode",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.payment_mode}</span>;
      },
    },
    {
      label: "Actions",
      key: "actions",
      sortable: false,
      width: "19%",

      searchable: false,
      render: (rowData) => {
        return (
          <div style={{ display: "flex", gap: "6px" }}>
            <ActionButton
              label="Edit"
              onClick={() => handleEditRetailer(rowData)}
            >
              <EditIcon style={{ fontSize: "1rem" }} />
            </ActionButton>
            <ActionButton
              label="View"
              color="success"
              onClick={() => handleManageRetailer(rowData)}
            >
              <FiEye fontSize="medium" />
            </ActionButton>
            <ActionButton
              label="Delete"
              color="error"
              onClick={() => handleDelete(`${rowData.id}`)}
            >
              <Trash size={17} />
            </ActionButton>
          </div>
        );
      },
    },
  ];

  const optionsData = {
    actionLabel: "Add Configuration",
    setAddModal: setOpened,
  };
  const [confirmedSearch, setConfirmedSearch] = useState("");

  const handleManualSearch = (searchTerm) => {
    setSearchValue(searchTerm);
  };
  const clearInput = () => {
    setSearchValue("");
    setConfirmedSearch("");
  };

  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Drawer
        opened={openedEdit}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        title="Editing a Configuration"
        onClose={() => setOpenedEdit(false)}
        padding="xl"
        size="80%"
        position="bottom"
      >
        <CommissionEditModal
          commistion={editId}
          setOpenedEdit={setOpenedEdit}
          isSme={isSme}
        />
      </Drawer>

      <Drawer
        opened={openedDetail}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        title="Configuration Detail"
        padding="xl"
        onClose={() => setOpenedDetail(false)}
        position="bottom"
        size="80%"
      >
        <CommisstionDetailModal
          total={total}
          setTotal={setTotal}
          activePage={activePage}
          setActivePage={setActivePage}
          setOpenedDetail={setOpenedDetail}
          commisstion={editId}
        />
      </Drawer>

      <Modal
        opened={openedDelete}
        onClose={() => setOpenedDelete(false)}
        title="Warning"
        centered
      >
        <p>Are you sure do you want todelete this Configuration?</p>
        <Group position="right">
          <Button onClick={() => deleteRetailer()} color="red">
            Delete
          </Button>
        </Group>
      </Modal>
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        padding="xl"
        size="80%"
        position="bottom"
      >
        <CommissionAddModal
          total={total}
          setTotal={setTotal}
          activePage={activePage}
          setActivePage={setActivePage}
          setOpened={setOpened}
          size={size}
          isSme={isSme}
        />
      </Drawer>

      <Card shadow="sm" p="lg">
        <ScrollArea>
          <B2bTable
            total={total}
            activePage={activePage}
            handleChange={handleChange}
            clearInput={clearInput}
            paginatorInfo={data.supplier_configurations.paginatorInfo}
            handelSearch={handleManualSearch}
            searchValue={confirmedSearch}
            onSearchChange={setConfirmedSearch}
            header={headerData}
            optionsData={optionsData}
            loading={loading}
            data={data ? data.supplier_configurations.data : []}
            size={size}
            handlePageSizeChange={handlePageSizeChange}
          />
        </ScrollArea>
      </Card>
    </div>
  );
};

export default SupplierCommission;
